import styled from 'styled-components';

const BlockStyled = styled.section`
    background: ${props =>
      props.targeted ? props.theme.block.targeted : props.theme.block.bg};
    border-radius: ${props => props.theme.block.borderRadius};
    border: ${props => props.theme.block.borderWidth} ${props =>
  props.theme.block.borderStyle} ${props => props.theme.block.borderColor};
    box-shadow: ${props => props.theme.block.boxShadow};
    overflow: hidden;
    opacity: ${props => (props.ready ? '1' : '0')};
    transform: ${props => (props.ready ? 'scale(0.95)' : 'scale(0.5)')};
    position: relative;
    transition: opacity ${props => props.theme.transition.durationShort},
        transform ${props => props.theme.transition.durationShort} ${props =>
  props.theme.transition.easeInOut},
        background ${props => props.theme.transition.durationShort};

    &.round-win,
    &.round-win:hover,
    &.round-win:focus {
        background: ${props => props.theme.block.bg};
        box-shadow: none;
        border-radius: 0;
        cursor: default;
        outline: 0;
        transform: scale(1);
    }

    &:not(.disabled) {
        &.selected,
        &.selected:hover,
        &.selected:focus {
            background: ${props => props.theme.block.selected};
            transform: scale(0.9);
        }

        &:hover,
        &:focus {
            background: ${props => props.theme.block.hover};
            cursor: pointer;
            outline: 0;
            transform: ${props =>
              !props.roundWin && props.selected ? `scale(0.9)` : `scale(1)`};

            .selectIcon {
                opacity: ${props => (props.selected ? '1' : '0')};
                transform: ${props =>
                  props.selected
                    ? 'translate(-50%, -50%) scale(1)'
                    : 'translate(-50%, -50%) scale(0)'};
            }
        }
    }


    @media screen and (min-width: ${props => props.theme.breakpoints.lg})  {
        > .landscape {
            left:   ${props =>
              props.blockOffsetPos === 'block1' ||
              props.blockOffsetPos === 'block5' ||
              props.blockOffsetPos === 'block9'
                ? '-100%'
                : props.blockOffsetPos === 'block2' ||
                  props.blockOffsetPos === 'block6' ||
                  props.blockOffsetPos === 'block10'
                  ? '-200%'
                  : props.blockOffsetPos === 'block3' ||
                    props.blockOffsetPos === 'block7' ||
                    props.blockOffsetPos === 'block11'
                    ? '-300%'
                    : '0'};
            top:    ${props =>
              props.blockOffsetPos === 'block4' ||
              props.blockOffsetPos === 'block5' ||
              props.blockOffsetPos === 'block6' ||
              props.blockOffsetPos === 'block7'
                ? '-100%'
                : props.blockOffsetPos === 'block8' ||
                  props.blockOffsetPos === 'block9' ||
                  props.blockOffsetPos === 'block10' ||
                  props.blockOffsetPos === 'block11'
                  ? '-200%'
                  : '0'};
            };
        }
    }

    @media screen and (max-width: ${props => props.theme.breakpoints.lg})  {
        > .portrait {
            left:   ${props =>
              props.blockOffsetPos === 'block1' ||
              props.blockOffsetPos === 'block4' ||
              props.blockOffsetPos === 'block7' ||
              props.blockOffsetPos === 'block10'
                ? '-100%'
                : props.blockOffsetPos === 'block2' ||
                  props.blockOffsetPos === 'block5' ||
                  props.blockOffsetPos === 'block8' ||
                  props.blockOffsetPos === 'block11'
                  ? '-200%'
                  : '0'};
            top:    ${props =>
              props.blockOffsetPos === 'block3' ||
              props.blockOffsetPos === 'block4' ||
              props.blockOffsetPos === 'block5'
                ? '-100%'
                : props.blockOffsetPos === 'block6' ||
                  props.blockOffsetPos === 'block7' ||
                  props.blockOffsetPos === 'block8'
                  ? '-200%'
                  : props.blockOffsetPos === 'block9' ||
                    props.blockOffsetPos === 'block10' ||
                    props.blockOffsetPos === 'block11'
                    ? '-300%'
                    : '0'};
            };
        }
    }
`;

export default BlockStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/Block/Block.styled.js